/* eslint-disable @typescript-eslint/no-explicit-any */
import { AccordionListView, IconButton } from "@enfusion-ui/web-components";
import { styled, useTabs } from "@enfusion-ui/web-core";
import { faDesktop, faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import * as React from "react";

import DirectoryExplorer from "./DirectoryExplorer";

const createExplorer = () =>
  React.memo(function ServiceFileExplorer({ open }: { open: boolean }) {
    return <DirectoryExplorer open={open} />;
  });

const defaultOpen = { file: true, dashboards: true };

const getItems = () => {
  let items = [
    {
      key: "file",
      title: "Saved Requests",
      contentComponent: createExplorer(),
    },
  ];
  return items;
};

const DirectorySidebarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const DirectorySidebarTitle = styled.div`
  height: 40px;
  padding: 0 0.25rem 0 0.75rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
`;

export const DirectorySidebar = () => {
  const listItems = React.useMemo(() => getItems(), []);
  const { openTab } = useTabs();

  const openNewTab = () => {
    openTab({
      component: "inspector",
      name: "New Tab",
      icon: faDesktop,
    });
  };

  return (
    <DirectorySidebarContainer>
      <DirectorySidebarTitle>
        <div style={{ flex: 1 }}>Inspector Explorer</div>
        <IconButton
          hoverable
          title="New Tab"
          icon={faPlusCircle}
          onClick={openNewTab}
          style={{ width: 24 }}
        />
      </DirectorySidebarTitle>
      <AccordionListView defaultOpen={defaultOpen} items={listItems} />
    </DirectorySidebarContainer>
  );
};
